import { useCallback } from "react";

import { useDateFormatSelect } from "store";
import { FormatDateUtil } from "store/types";
import { formatDate } from "utils";

export function useFormatDateHook(): FormatDateUtil {
  const formatFromConfig = useDateFormatSelect();

  return useCallback(({ format, ...rest }) => {
    return formatDate({ format: format || formatFromConfig, ...rest });
  }, [formatFromConfig]);
}
